/**
 * Sets webpack's public path at runtime from the MFE's own <script src="..."> tag,
 * BEFORE any imports resolve. This must be imported first in main.ts.
 *
 * Why: the build hardcodes --deploy-url (e.g. https://referral-collaboration-dev.na.chubb.com/)
 * into __webpack_public_path__. When the same bundle is served from somewhere else
 * (a local live-server on :5500, a different env's CDN), the bundle still asks for
 * chunks and assets from the baked URL — wrong origin, CORS / 404.
 *
 * document.currentScript is the <script> tag currently executing. Inside the IIFE
 * that wraps the webpack bundle, this is still set to the script tag that loaded
 * main.js, so we can recover the real serving origin from it.
 */

declare let __webpack_public_path__: string;

const currentScript = document.currentScript as HTMLScriptElement | null;
if (currentScript?.src) {
  __webpack_public_path__ = currentScript.src.substring(0, currentScript.src.lastIndexOf('/') + 1);
  // eslint-disable-next-line no-console
  console.log('[set-public-path] __webpack_public_path__ =', __webpack_public_path__);
} else {
  // eslint-disable-next-line no-console
  console.warn('[set-public-path] document.currentScript not available — falling back to build-time --deploy-url');
}
